/**
 * GrowthOverviewPage - 成长档案概况（CMS 管理后台内）
 * 调用 P1 API：/cms/api/growth/*
 */
import { useState, useEffect } from 'react'
import { Card, Statistic, Row, Col, Table, Tag, Input, message, Empty } from 'antd'
import { UserOutlined, PictureOutlined, BookOutlined } from '@ant-design/icons'

export default function GrowthOverviewPage() {
  const [childId, setChildId] = useState('')
  const [profile, setProfile] = useState(null)
  const [tags, setTags] = useState(null)
  const [summary, setSummary] = useState(null)
  const [loading, setLoading] = useState(false)

  async function search() {
    if (!childId.trim()) { message.warning('请输入孩子ID'); return }
    setLoading(true)
    try {
      var [pr, tr, sr] = await Promise.all([
        fetch('/cms/api/growth/profile/' + encodeURIComponent(childId.trim())).then(function(r) { return r.json() }),
        fetch('/cms/api/growth/tags/' + encodeURIComponent(childId.trim())).then(function(r) { return r.json() }),
        fetch('/cms/api/growth/summary/' + encodeURIComponent(childId.trim())).then(function(r) { return r.json() }),
      ])
      if (pr.success) setProfile(pr)
      if (tr.success) setTags(tr)
      if (sr.success) setSummary(sr)
    } catch(e) { message.error('查询失败') }
    setLoading(false)
  }

  return (
    <div style={{ padding: 24 }}>
      <h2 style={{ marginBottom: 24 }}>📈 成长档案概况</h2>

      <Card style={{ marginBottom: 24 }}>
        <div style={{ display: 'flex', gap: 12, alignItems: 'center' }}>
          <span style={{ fontSize: 14, whiteSpace: 'nowrap' }}>孩子ID：</span>
          <Input
            placeholder="输入孩子ID（如 CH1780546141340dk2j）"
            value={childId}
            onChange={function(e) { setChildId(e.target.value) }}
            onPressEnter={search}
            style={{ maxWidth: 400 }}
          />
          <button onClick={search} style={{
            padding: '4px 20px', background: '#667eea', color: 'white',
            border: 'none', borderRadius: 6, cursor: 'pointer'
          }}>查询</button>
        </div>
      </Card>

      {summary && summary.success && (
        <>
          <Row gutter={24} style={{ marginBottom: 24 }}>
            <Col span={6}><Card><Statistic title="总创作数" value={summary.data.totalCreations || 0} prefix={<PictureOutlined />} /></Card></Col>
            <Col span={6}><Card><Statistic title="AI动画数" value={summary.data.animations || 0} prefix={<PictureOutlined />} /></Card></Col>
            <Col span={6}><Card><Statistic title="故事数" value={summary.data.stories || 0} prefix={<BookOutlined />} /></Card></Col>
            <Col span={6}><Card><Statistic title="本月创作" value={summary.data.thisMonth || 0} prefix={<UserOutlined />} /></Card></Col>
          </Row>

          {summary.data.topThemes && summary.data.topThemes.length > 0 && (
            <Card title="偏好主题 Top 3" style={{ marginBottom: 16 }}>
              {summary.data.topThemes.map(function(t) {
                return <Tag key={t.tag_value} color="purple" style={{ margin: '2px 4px' }}>{t.tag_value} ({t.cnt}次)</Tag>
              })}
            </Card>
          )}

          {summary.data.topColors && summary.data.topColors.length > 0 && (
            <Card title="偏好色系 Top 3" style={{ marginBottom: 16 }}>
              {summary.data.topColors.map(function(c) {
                return <Tag key={c.tag_value} color="magenta" style={{ margin: '2px 4px' }}>{c.tag_value} ({c.cnt}次)</Tag>
              })}
            </Card>
          )}
        </>
      )}

      {!summary && !loading && (
        <Empty description="输入孩子ID后查询成长数据" />
      )}
    </div>
  )
}
